module.exports = __webpack_public_path__ + "static/media/sebrae.3c59f02d.svg";